import { useLocation } from 'react-router-dom'
import MainLayout from 'layouts/main-layout/main-layout'
import LandingPage from 'pages/landing/landing.page'

const RootLayout = () => {
  const { pathname } = useLocation()

  if (pathname === '/') {
    return <LandingPage />
  }

  return <MainLayout />
}

export default RootLayout
